import { StatusCommande } from '@/enum/StatusCommande';
import Vue from 'vue'

export const colorStatusCmd = (value: number) => {    
    switch(value){
        case StatusCommande.bcd: return "";
        case StatusCommande.paye: return "#A6F562";
        case StatusCommande.preparation: return "#4C8EF5";
        case StatusCommande.envoye: return "#F5CA73";
        case StatusCommande.livre: return "#E758F5";
        case StatusCommande.annule: return "#F57F65";
        case StatusCommande.rembourse: return "";
        case StatusCommande.enLivraison: return "";
        case StatusCommande.enAttentePaiement: return "ab4eed";
        case StatusCommande.devis: return "";
        case StatusCommande.enCoursAppro: return "";
        case StatusCommande.erreur: return "";
    }
    return "";     
}
Vue.filter('colorStatusCmd', colorStatusCmd)